import { render, staticRenderFns } from "./RemoteConsultationEvaluate.vue?vue&type=template&id=1a554d31&"
import script from "./RemoteConsultationEvaluate.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationEvaluate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports